import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dca3d3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "two-column-row" }
const _hoisted_3 = { class: "tab-content" }

import { computed, inject, PropType, ref, watch } from "vue";
import { DxContextMenu } from "devextreme-vue/context-menu";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { MaintenanceRequestsValidation } from "acquaint-api/validation/MaintenanceRequestsValidation";
import displayErrorMessage from "@/utils/ErrorHandling";
import { MaintenanceRequests } from "acquaint-api/models/MaintenanceRequests";
import { CodeType } from "acquaint-api/constants/CodeType";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import WorkOrderModal from "@/components/work-orders/work-order-modal.vue";
import MaintenanceRequestPictureTab from "./maintenance-request-picture-tab.vue";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { MaintenanceRequestStatus } from "@/enums/maintenance-requests/MaintenanceRequestStatus";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { Templates } from "@/enums/constants/Templates";
import { CurrentUser } from "@/types/user/CurrentUser";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { formatDate } from "bright-logic-core/src/format";
import { useLookupConfigurationStore } from "@/stores/LookupConfigurationStore";
import { computedAsync } from "@vueuse/core";
import { MaintenanceRequestItem } from "@/types/maintenance-requests/MaintenanceRequestItem";


export default /*#__PURE__*/_defineComponent({
  __name: 'maintenance-request-item-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** Selected MaintenanceRequestItem object
   * @type {MaintenanceRequestItem}
   * @required: true
   */
  maintenanceRequestItem: {
    type: Object as PropType<MaintenanceRequestItem>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the status has been changed.
   * This can be used to notify the parent component that the maintenance request status has been changed.
   */
  "statusChanged",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const lookupConfigurationStore = useLookupConfigurationStore();
const selectedTab = ref(0);
const defaultMaintenanceRequests: MaintenanceRequests = {
  id: 0,
  addedDate: "",
  subject: "",
  body: "",
  contactID: 0,
  contactFirstNames: "",
  contactLastName: "",
  contactEmail: "",
  contactTelephone: "",
  propertyID: 0,
  propertyStreet: "",
  propertyPostcode: "",
  siteID: 0,
  workOrderTypeID: 0,
  status: 0,
  statusDate: "",
  userID: 0,
  pictures: 0,
  externalID: 0,
  workOrderID: 0,
};

const maintenanceRequestData = ref<MaintenanceRequests>({
  ...defaultMaintenanceRequests,
});

const displayEmailFormModal = ref(false);
const displayNewWorkOrderModal = ref(false);
const showFunctionsMenu = ref(false);
const contextMenuId = ref("maintenance-request-action-menu");

watch(
  () => showModal.value,
  async () => {
    if (showModal.value) {
      currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
      selectedTab.value = 0;

      await fetchItemData();
    }
  },
);

const fetchItemData = async () => {
  try {
    if (props.maintenanceRequestItem.id > 0) {
      maintenanceRequestData.value =
        await acquaintApiClient.httpGet<MaintenanceRequests>(
          `database/maintenancerequests/${props.maintenanceRequestItem.id}`,
        );
    }
  } catch (err) {
    maintenanceRequestData.value = { ...defaultMaintenanceRequests };
    displayErrorMessage("The selected details could not be fetched");
  }
};

const cancelClick = () => {
  showModal.value = false;
};

const modalClosed = async () => {
  showModal.value = false;
};

const menuItems = computed(() => {
  const menu: ContextMenuItem[] = [
    {
      text: "Work Order",
      key: "workOrder",
      icon: "",
      disabled:
        maintenanceRequestData.value?.status ===
        MaintenanceRequestStatus.ConvertedToWorkOrder,
    },
    {
      text: "Reject",
      key: "reject",
      icon: "",
    },
  ];

  return menu;
});
const onMenuItemClick = async (e: any) => {
  let question;
  if (!maintenanceRequestData.value) return;

  switch (e.itemData.key) {
    case "workOrder":
      displayNewWorkOrderModal.value = true;
      break;
    case "reject":
      question = await displayQuestionAlert(
        "Are you sure you want to do this?",
      );

      if (!question.isConfirmed) {
        return;
      }
      if (maintenanceRequestData.value.contactID > 0) {
        question = await displayQuestionAlert(
          "Would you like to email the contact who submitted the Maintenance Request?",
        );

        if (question.isConfirmed) {
          displayEmailFormModal.value = true;
        }
      } else {
        await setMaintenanceRequestStatusToRejected(
          maintenanceRequestData.value.id,
        );
      }
      break;
  }
};

const onEmailSent = async () => {
  if (!maintenanceRequestData.value) return;

  await setMaintenanceRequestStatusToRejected(maintenanceRequestData.value.id);
};
const setMaintenanceRequestStatusToActioned = async (
  id: number,
  workOrderId: number,
) => {
  try {
    await acquaintApiClient.httpGetVoid(
      `app/maintenancerequests/${id}/workorder/${workOrderId}`,
    );
    showModal.value = false;
    emit("statusChanged");
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const setMaintenanceRequestStatusToRejected = async (id: number) => {
  try {
    await acquaintApiClient.httpGetVoid(
      `app/maintenancerequests/${id}/SetAsRejected`,
    );
    showModal.value = false;
    emit("statusChanged");
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const onWorkOrderCreated = async (workOrderId: number) => {
  await setMaintenanceRequestStatusToActioned(
    props.maintenanceRequestItem.id,
    workOrderId,
  );
};

const getContactDescriptionById = async (contactId: number) => {
  return await lookupConfigurationStore.getLookupConfigurationDescription(
    LookupTableSource.Users,
    contactId,
  );
};

const propertyName = computedAsync(async () => {
  const id = maintenanceRequestData.value?.propertyID ?? 0;
  if (id > 0) {
    return `${maintenanceRequestData.value.propertyStreet} ${maintenanceRequestData.value.propertyPostcode}`;
  }
  return props.maintenanceRequestItem.property;
}, "");

const contactName = computedAsync(async () => {
  const id = maintenanceRequestData.value?.contactID ?? 0;
  if (id > 0) {
    return `${maintenanceRequestData.value.contactFirstNames} ${maintenanceRequestData.value.contactLastName} (Email: ${maintenanceRequestData.value.contactEmail}, Telephone: ${maintenanceRequestData.value.contactTelephone})`;
  }
  return `${props.maintenanceRequestItem.contact} (Email: ${props.maintenanceRequestItem.email}, Telephone: ${props.maintenanceRequestItem.contactNumber})`;
}, "");

const userName = computedAsync(async () => {
  const id = maintenanceRequestData.value?.userID ?? 0;
  if (id > 0) {
    return await getContactDescriptionById(id);
  }
  return "";
}, "");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showModal).value = $event)),
      title: "Maintenance Request",
      height: "660",
      onModalClosed: modalClosed
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Main Details" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(AcquaintInfoBox, {
                    text: _unref(contactName),
                    label: "Contact"
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoBox, {
                    text: _unref(propertyName),
                    label: "Property"
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoBox, {
                    text: maintenanceRequestData.value.subject,
                    label: "Subject"
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintTextArea, {
                    fieldValidation: _unref(MaintenanceRequestsValidation).Body,
                    label: "Details",
                    modelValue: maintenanceRequestData.value.body,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((maintenanceRequestData.value.body) = $event)),
                    readOnly: true,
                    validationGroup: "MaintenanceRequestValidationGroup"
                  }, null, 8, ["fieldValidation", "modelValue"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(SystemCodeSingleSelect, {
                      "code-type": _unref(CodeType).MaintenanceRequestStatus,
                      label: "Status",
                      modelValue: maintenanceRequestData.value.status,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((maintenanceRequestData.value.status) = $event)),
                      readOnly: true
                    }, null, 8, ["code-type", "modelValue"]),
                    _createVNode(AcquaintInfoBox, {
                      text: _unref(formatDate)(maintenanceRequestData.value.statusDate, false),
                      label: "Status Date"
                    }, null, 8, ["text"]),
                    _createVNode(AcquaintInfoBox, {
                      text: _unref(userName),
                      label: "Actioned By"
                    }, null, 8, ["text"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Pictures" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(MaintenanceRequestPictureTab, { maintenanceRequests: maintenanceRequestData.value }, null, 8, ["maintenanceRequests"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          elementAttr: { id: contextMenuId.value },
          visible:
            maintenanceRequestData.value.status ===
            _unref(MaintenanceRequestStatus).Outstanding,
          text: 'Actions',
          onClick: () => {
            showFunctionsMenu.value = !showFunctionsMenu.value;
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          visible: true,
          text: 'Cancel',
          onClick: () => {
            cancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(DxContextMenu), {
      visible: showFunctionsMenu.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showFunctionsMenu).value = $event)),
      "data-source": menuItems.value,
      target: `#${contextMenuId.value}`,
      position: { my: 'bottom right', at: 'top right' },
      onItemClick: onMenuItemClick
    }, null, 8, ["visible", "data-source", "target"]),
    _createVNode(WorkOrderModal, {
      modelValue: displayNewWorkOrderModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((displayNewWorkOrderModal).value = $event)),
      maintenanceRequests: maintenanceRequestData.value,
      fromMaintenanceRequest: true,
      onWorkOrderCreated: onWorkOrderCreated
    }, null, 8, ["modelValue", "maintenanceRequests"]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailFormModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((displayEmailFormModal).value = $event)),
      emailTemplateId: _unref(Templates).MaintenanceRequestRejection,
      userId: currentUserDetails.value?.id,
      contactList: [maintenanceRequestData.value.contactID],
      onEmailSent: onEmailSent,
      onCancelPromptAccepted: onEmailSent
    }, null, 8, ["modelValue", "emailTemplateId", "userId", "contactList"])
  ], 64))
}
}

})